import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d50df08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "button-text"
}
const _hoisted_2 = {
  key: 1,
  class: "button-text"
}
const _hoisted_3 = {
  key: 0,
  class: "button-text"
}
const _hoisted_4 = {
  key: 1,
  class: "button-text"
}

import { PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
	isSmall: Boolean,
	isMobile: Boolean,
	menuItem: { type: Object as PropType<MenuItem>, required: true },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.menuItem.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.menuItem.to,
        class: _normalizeClass({
			'menu-item': true,
			'menu-item--mobile': __props.isMobile,
			'menu-item--small': __props.isSmall,
			active: __props.menuItem.isActive,
		})
      }, {
        default: _withCtx(() => [
          (__props.menuItem.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createElementVNode("i", {
                  class: _normalizeClass(__props.menuItem.icon)
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          (__props.menuItem.label && (__props.isMobile || (!__props.menuItem.isHideLabelDesktop && !__props.isMobile)))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.menuItem.label), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to", "class"]))
    : (!!__props.menuItem.onClick)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass({
			'menu-item': true,
			'menu-item--mobile': __props.isMobile,
			'menu-item--small': __props.isSmall,
		}),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.menuItem.onClick && __props.menuItem.onClick(...args)))
        }, [
          (__props.menuItem.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createElementVNode("i", {
                  class: _normalizeClass(__props.menuItem.icon)
                }, null, 2)
              ]))
            : _createCommentVNode("", true),
          (__props.menuItem.label && (__props.isMobile || (!__props.menuItem.isHideLabelDesktop && !__props.isMobile)))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.menuItem.label), 1))
            : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({ spacer: true, 'spacer--mobile': __props.isMobile, 'spacer--desktop': !__props.isMobile })
        }, null, 2))
}
}

})